/**
 * Projects Selectors
 */

import { getTrackFromProps, getTrackIdFromProps, IPropsWithTrackId, IPropsWithTrackResult } from '../../utils/track';
import { getPlayerState } from './player';
import { addToProjectPanelIsVisible, getAddToProjectTrackId } from './ui';

import { some } from 'lodash';
import { createSelector } from 'reselect';

export const getProjects = ({ projects }: IStoreState) => projects;
export const isTrackInProjects = (projects: IProjectsState, trackId: string | undefined) => {
  return !!projects && !!trackId && some(projects, (project) => project.indexOf(trackId) > -1);
};

export const isCurrentPlayingTrackInProject = createSelector(
  [getProjects, getPlayerState],
  (projects, { currentTrack }) => {
    if (!currentTrack) {
      return false;
    }

    return isTrackInProjects(projects, currentTrack.trackInfo.id);
  },
);

export const makeIsTrackInProjects = (withTrackId = true) => {
  const trackIdSelector = withTrackId ? getTrackIdFromProps : getTrackFromProps;
  // tslint:disable-next-line:max-line-length
  return createSelector<IStoreState, IPropsWithTrackId | IPropsWithTrackResult, IProjectsState, (GQL.ITrackSearchResult | string) | undefined, boolean>(
    [getProjects, trackIdSelector],
    (projects, track) => {
      return track ? isTrackInProjects(projects, typeof track === 'string' ? track : track.id) : false;
    },
  );
};

export const isAddToProjectOpen = createSelector(
  [addToProjectPanelIsVisible, getAddToProjectTrackId, getPlayerState],
  (isVisible, trackId, { currentTrack }) => {
    return isVisible && !!trackId && !!currentTrack && trackId === currentTrack.trackId;
  },
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/selectors/projects.ts